import {useAppSelector } from "../../../../Redux/store"
import { postScreenSizeMessage } from "../../../../hooks/screenSize";


export const SandboxScreen = () => {
    const { codeSrc } = useAppSelector(state => state.developerSandbox);

    return (
        <div className="w-full h-full">
            <iframe 
                id='iframe'
                title="sandbox" 
                src={`data:text/html,${codeSrc}`} 
                height={280} 
                width={280}
                className="bg-white border-none w-full h-full block m-0"
                onLoad={() => postScreenSizeMessage()}
            />       
        </div>    
    )
}
